import React, {useState, useRef, useEffect} from 'react';
import { getLabel } from '../../data/labels';
import { addPrintOverlay } from '../utils/addPrintOverlay';
import { getConfiguration } from '../utils/configuration';
import { removePrintOverlay } from '../utils/removePrintOverlay';
import ShopReceiptPrinter from './ShopReceiptPrinter';
import { ShopReceiptPrinterContext } from './ShopReceiptPrinterContext';

function ShopReceiptPrinterConf(props) {
	const conf = getConfiguration();
	const ctxs = useRef({}).current;
	ctxs.selfContext = props.selfContext;
	function getBackendReceiptTemplateId(frontendTemplateId){
		let template = null;
		if(frontendTemplateId){
			switch(frontendTemplateId){
			case 'grantCash':
                template = 'GRANT_CASH';
                break;
			case 'returnCash':
                template = 'RETURN_CASH';
                break;
			case 'voucher':
                template = 'GENERATE_PHYSICAL_REST_VOUCHER';
                break;
			case 'paymentTicket':
                template = 'PAY_TICKET';
                break;
			case 'cancelTicket':
                template = 'CANCEL_TICKET';
                break;
			case 'detailedBalance':
                template = 'DETAILED_BALANCE';
                break;
			case 'pickingReceipt':
                template = 'CASH_PICKING_REPORT';
                break;
			case 'transactionsLog':
                template = 'CASHIER_TRANSACTION_LOGS';
                break;
			case 'physicalSelfAccountRechargeReport':
                template = 'PHYSICAL_SELF_ACCOUNT_RECHARGE_REPORT';
                break;
			case 'physicalRestVoucherPayment':
                template = 'PAY_PHYSICAL_SELF_VOUCHER';
                break;
			case 'posBalance':
                template = 'POS_BALANCE';
                break;
			case 'dailyShopDetailedBalance':
                template = 'DAILY_SHOP_DETAILED_BALANCE';
                break;
			case 'posBalanceReport':
                template = 'POS_BALANCE_REPORT';
                break;
			case 'monthlyCommissionReport':
                template = 'MONTHLY_COMMISSION_REPORT';
                break;
			case 'reserveDepositForFinalUserReceipt':
                template = 'RESERVE_DEPOSIT_FOR_FINAL_USER_RECEIPT';
                break;
			case 'thirdPartyVoucherPaymentReceipt':
                template = 'THIRD_PARTY_VOUCHER_PAYMENT_RECEIPT';
                break;
			case 'withdrawRequestReceipt':
                template = 'WITHDRAW_REQUEST_RECEIPT';
                break;
			case 'scratchCardPaymentReceipt':
                template = 'SCRATCH_CARD_PAYMENT_RECEIPT';
                break;
			case 'accountRechargeReceipt':
                template = 'ACCOUNT_RECHARGE_RECEIPT';
                break;
			case 'cashoutReceipt':
                template = 'CASHOUT_RECEIPT';
                break;
            case 'rechargeVoucherReceipt':
               	template = 'RECHARGE_VOUCHER_RECEIPT';
                break;
            default:
                break;
			}
		}
		return template;
	}
	
	function mustBePrintedBySocket(template){
		if(ctxs.selfContext && ctxs.selfContext.mustBePrintedBySocket && template){
			return ctxs.selfContext.mustBePrintedBySocket(template);
		}
		return false;
	}
	
	
	const [shopReceiptPrinterContext, setShopReceiptPrinterContext] = useState({
		receiptType : null,
		receiptData : null,
		showHtml : false,
		
		updateFullContext : function(updt) {
			// updating temporary
			for(let ko in updt){
				const val = updt[ko];
				ctxs.shopReceiptPrinterContext[ko] = val;
			}
			//update effectly
			setShopReceiptPrinterContext(prev => {
                return {...prev, ...updt};
            });
        },
        
		printVoucherReceipt: function (operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'voucher', showHtml);
		},
		
		printGrantCashReceipt: function (operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'grantCash', showHtml);
		},
		
		printReturnCashReceipt: function (operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'returnCash', showHtml);
		},
		
		printPaymentTicketReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'paymentTicket', showHtml);
		},
		
		printCancelTicketReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'cancelTicket', showHtml);
		},
		
		printDetailedBalance : function(operationData, showHtml){
			const showPreview = conf.rs.dbp && window.setModalPrinterPreview;;
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'detailedBalance', showHtml, showPreview);
		},

		printPosBalance : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'posBalance', showHtml);
		},

		printPickingReceipt(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'pickingReceipt', showHtml);
		},

		printTransactionsLog(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'transactionsLog', showHtml);
		},

		printPhysicalSelfAccountRechargeReport(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'physicalSelfAccountRechargeReport', showHtml);
		},
		
		printPhysicalRestVoucherPaymentReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'physicalRestVoucherPayment', showHtml);
		},
		printDailyShopDetailedBalance : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'dailyShopDetailedBalance', showHtml);
		},
		
		printPosBalanceReport : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'posBalanceReport', showHtml);
		},
		printMonthlyCommisionReport : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'monthlyCommissionReport', showHtml);
		},
		
		printReserveDepositForFinalUserReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'reserveDepositForFinalUserReceipt', showHtml);
		},
		printThirdPartyVoucherPaymentReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'thirdPartyVoucherPaymentReceipt', showHtml);
		},
		printwithdrawRequestReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'withdrawRequestReceipt', showHtml);
		},		
		printScratchCardPaymentReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'scratchCardPaymentReceipt', showHtml);
		},		
		printAccountRechargeReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'accountRechargeReceipt', showHtml);
		},
		printCashoutReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'cashoutReceipt', showHtml);
		},
		printRechargeVoucherReceipt : function(operationData, showHtml){
			ctxs.shopReceiptPrinterContext.setPrintStart(operationData, 'rechargeVoucherReceipt', showHtml);
		},
		setPrintStart : function(receiptData, receiptType, showHtml, showPreview){
			const socketReceiptId = getBackendReceiptTemplateId(receiptType); 
			if(mustBePrintedBySocket(socketReceiptId)){
				if(socketReceiptId == 'CASHIER_TRANSACTION_LOGS'){
					receiptData = {'transactions':receiptData}
				}
				window.XSocket.printReceipt(receiptData, socketReceiptId);
			}
			else {
				if(!showPreview){
					addPrintOverlay(() => {
						ctxs.selfContext.freezeAllPermanent(getLabel('general.printing_receipt'));
					});				
				}
				ctxs.shopReceiptPrinterContext.updateFullContext({
					receiptType,
					receiptData,
					showHtml
				});
			}

		},
		
		setPrintDone : function(){
			setTimeout(() => {
				removePrintOverlay(ctxs.selfContext.unfreezeAll())
			},2000);
			ctxs.shopReceiptPrinterContext.updateFullContext({
				receiptType : null,
				receiptData : null,
				showHtml : false
			});
		}
		
	});
	ctxs.shopReceiptPrinterContext = shopReceiptPrinterContext;
	useEffect(() => {
		const receiptData = ctxs.shopReceiptPrinterContext.receiptData; 
		const receiptType = ctxs.shopReceiptPrinterContext.receiptType;
		if(receiptData && props.apkPosLite){
			window.printFailed = function(err){
				console.log('[PRINT ERROR]' + err);
				function printFailedFunction(){
					window.printFailed = null;
					ctxs.shopReceiptPrinterContext.setPrintStart(receiptData, receiptType, false);
				}
				ctxs.selfContext.showPrintErrorMessage(printFailedFunction);
				
			};
		}
	}, [ctxs.shopReceiptPrinterContext.receiptData]);
	return (
    	<ShopReceiptPrinterContext.Provider value={ctxs.shopReceiptPrinterContext}>
    		{
    			ctxs.shopReceiptPrinterContext.receiptData && (<ShopReceiptPrinter  />)
    		}
			{props.children}
    	</ShopReceiptPrinterContext.Provider>
	);	
}

export default ShopReceiptPrinterConf;